import {Component, Input, OnInit} from '@angular/core';
import {RewardService} from "../../../../../shared/services/reward.service";
import {ParamService} from "../../../../../shared/services/param.service";

@Component({
  selector: 'app-promotion-terms',
  templateUrl: './promotion-terms.component.html',
  styleUrls: ['./promotion-terms.component.scss']
})
export class PromotionTermsComponent implements OnInit {

    @Input() partnerDetails: any;
    partnerDetailContentURL: any;
    termsContent: any;
    showLoading = true;
    isErrorInContent = false;
    banner: any;
    @Input() isWebView;
    bannerPlaceholder = '(displayableBanner)';
    constructor(private rewardService: RewardService, private paramService: ParamService) { }

    ngOnInit(): void {
        this.banner = this.paramService.banner;
        if (this.partnerDetails) {
            if (this.partnerDetails.contentPath) {
              this.partnerDetailContentURL = this.partnerDetails.contentPath;
              if(this.isWebView) {
                this.partnerDetailContentURL = this.rewardService.getMobileApplicationDomainURL(this.partnerDetails.currentEnvironment, this.partnerDetails.banner) + '/' + this.partnerDetailContentURL.replace(/\{partner_section\}/g, 'terms-conditions');
              } else {
                this.partnerDetailContentURL = this.rewardService.getApplicationDomainURL() + '/' + this.partnerDetailContentURL.replace(/\{partner_section\}/g, 'terms-conditions');
              }
              this.getPartnerDetailContentAPI();
            }
        }
    }

    getPartnerDetailContentAPI(){
        this.rewardService.getPromotionDetailContent(this.partnerDetailContentURL).subscribe((promotionDetailData: any) => {
            if(promotionDetailData){
                this.showLoading = false;
                this.termsContent = this.replaceBannerInTerms(promotionDetailData);
                this.termsContent = this.interpretHtmlContentForNVDA(this.termsContent);
            }
        }, error => {
                     this.showLoading = false;
                     this.isErrorInContent = true;
                });
    }


    replaceBannerInTerms(terms: string): string{
        if(terms)  {
            return terms.replace(/\(displayableBanner\)/g, this.banner);
        }
    }

    interpretHtmlContentForNVDA(content: string):string{
        if(content){
           return content.replace(/\be\.g\.,/g, `
           <span aria-hidden="true">e.g.,</span>
           <span class="sr-only">example</span>
           `);
        }
    }

}
